import cl from 'classnames';
import { noop } from 'lodash';
import * as React from 'react';
import useDimensions from 'react-cool-dimensions';
import { useInView } from 'react-cool-inview';
import styled, { css } from 'styled-components';

import { colorsV2 } from '../../../../../../colors-v2';
import { Typography } from '../../../../../../DesignSystemV2/Typography';
import { DoTestQuizAnswerModeEnum } from '../../../types';

/* stylelint-disable no-descending-specificity */
export const OptionShareStyles = css`
  &.${DoTestQuizAnswerModeEnum.DO_TEST} {
    cursor: pointer;
    border: 1px solid ${colorsV2.gray40};
    &:hover {
      border: 1px solid ${colorsV2.gray100};
    }
    &:active,
    &.selected {
      background: ${colorsV2.blue10};
      border: 2px solid ${colorsV2.blue100};
    }
    .poll-result {
      display: none;
    }
  }

  &.${DoTestQuizAnswerModeEnum.RESULT_WRONG} {
    border: 2px solid ${colorsV2.red100};
    .progress-bar {
      background-color: ${colorsV2.red20};
    }
    .choice-wrapper {
      color: ${colorsV2.black100};
    }
  }

  &.${DoTestQuizAnswerModeEnum.RESULT_CORRECT} {
    border: 2px solid ${colorsV2.green100};
    .progress-bar {
      background-color: ${colorsV2.green20};
    }
    .choice-wrapper {
      color: ${colorsV2.black100};
    }
  }

  &.${DoTestQuizAnswerModeEnum.RESULT_DEFAULT} {
    border: 1px solid ${colorsV2.gray20};
    .progress-bar {
      background-color: ${colorsV2.gray20};
    }
    .poll-result {
      display: none !important;
      color: ${colorsV2.gray100};
    }
  }
`;

/* stylelint-disable no-duplicate-selectors */
const Main = styled.div`
  ${OptionShareStyles}
  position: relative;
  border-radius: 8px;
  padding: 14px 20px;
  min-height: 56px;
  overflow: hidden;

  .progress-bar {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    width: 1px;
    transform-style: preserve-3d;
    transform-origin: left;
  }
  .choice-wrapper {
    position: relative;
    z-index: 6;
    display: grid;
    grid-template-columns: minmax(0, 1fr) max-content;
    gap: 24px;
    .choice {
      z-index: 6;
      position: relative;
      display: grid;
      align-items: center;
    }
    .poll-result {
      z-index: 6;
      position: relative;
      text-align: right;
      place-items: center;
    }
  }

  &.${DoTestQuizAnswerModeEnum.RESULT_WRONG},
    &.${DoTestQuizAnswerModeEnum.RESULT_CORRECT},
    &.${DoTestQuizAnswerModeEnum.RESULT_DEFAULT} {
    .poll-result {
      display: grid;
    }
  }
`;

interface OptionTextProps {
  mode: DoTestQuizAnswerModeEnum;
  selected?: boolean;
  text: string;

  percentage?: number;
  onClick?: (e: any) => void;
}

export const OptionText = (props: OptionTextProps) => {
  const { mode, selected, percentage = 0, text, onClick = noop } = props;
  const inViewTrack = useInView({
    // Stop observe when the target enters the viewport, so the "inView" only triggered once
    unobserveOnEnter: true,
    // For better UX, we can grow the root margin so the image will be loaded before it comes to the viewport
    rootMargin: '50px',
  });
  const { observe, width } = useDimensions<HTMLDivElement | null>();

  return (
    <Main
      onClick={onClick}
      ref={observe}
      className={cl('quizz-answer-option-text', mode, { selected })}
    >
      <div
        style={{
          transform: `scaleX(${width !== undefined ? ((width + 40) * percentage) / 100 : 0})`,
        }}
        className="progress-bar"
      />
      <div ref={inViewTrack.observe} className="choice-wrapper">
        <Typography.Paragraph variant="regular/18" className="choice">
          {text}
        </Typography.Paragraph>
        <div className="poll-result">
          <Typography.Paragraph variant="semi-bold/12">{percentage}% chọn</Typography.Paragraph>
        </div>
      </div>
    </Main>
  );
};
